/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef, useState, useEffect, useContext } from 'react';
import { Menu, MenuItem, IconButton } from '@one-thd/sui-atomic-components';
import { MenuMeatballs } from '@one-thd/sui-icons';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ON_CLOSE_MEATBALLS } from '../../constants/custom-events';
import styles from './meatballs-menu.module.scss';
export var MeatballsMenu = function (_a) {
    var label = _a.label, items = _a.items;
    var menuBtnRef = useRef(null);
    var menuItemsRef = useRef(null);
    var _b = useState(false), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    var channel = useContext(ExperienceContext).channel;
    var isMobile = channel === 'mobile';
    var isPayPalMenu = items.some(function (el) { return el.payPalBtn; });
    var disableOnBlurClose = useRef(isMobile && isPayPalMenu);
    useEffect(function () {
        if (isMenuOpen && menuItemsRef.current) {
            // focusing on menu items when menu is opened helps properly close the menu on blur
            // do not need to register outside clicks for every address card or maintain some address card state
            menuItemsRef.current.focus();
            // Custom event to close meatballs after PayPal handlers
            document.addEventListener(ON_CLOSE_MEATBALLS, function () {
                setIsMenuOpen(false);
            });
        }
    }, [isMenuOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { icon: MenuMeatballs, ref: menuBtnRef, onClick: function () {
                setIsMenuOpen(!isMenuOpen);
            }, role: "combobox", "aria-label": "Edit ".concat(label), "aria-expanded": isMenuOpen, "aria-controls": "edit".concat(label, "Menu"), "aria-haspopup": "listbox", "data-testid": "meatballButton" }),
        React.createElement("div", { className: "sui-font-regular sui-text-base sui-leading-tight sui-px-3 sui-whitespace-nowrap" },
            React.createElement(Menu, { id: "edit".concat(label, "Menu"), placement: "bottom-end", open: isMenuOpen, anchorElementRef: menuBtnRef },
                isPayPalMenu && isMenuOpen && (React.createElement("div", { className: styles.backDrop, onClick: function () {
                        setIsMenuOpen(false);
                    } })),
                React.createElement("ul", { role: "listbox", ref: menuItemsRef, tabIndex: 0, onBlur: function () {
                        if (!disableOnBlurClose.current) {
                            setIsMenuOpen(false);
                        }
                    }, className: styles.listbox }, items.map(function (_a) {
                    var value = _a.value, isHidden = _a.isHidden, isDisabled = _a.isDisabled, payPalBtn = _a.payPalBtn, action = _a.action;
                    return (!isHidden && (React.createElement(MenuItem, { key: value, value: value, disabled: isDisabled, onClick: function () {
                            if (!payPalBtn) {
                                setIsMenuOpen(false);
                                action();
                            }
                        }, style: {
                            position: 'relative',
                        }, 
                        // Paypal button is iframe and when click event is happened on the button our meatballs with paypal modal are closed(unmounted). The reason is setIsMenuOpen(false) in onBlur event on menuItemsRef.
                        // We cannot intercept events from iframe so this hack help to disable onBlur in meatballs menu only for Edit PayPal option.
                        onMouseEnter: function () {
                            if (payPalBtn) {
                                disableOnBlurClose.current = true;
                            }
                        }, onMouseLeave: function () {
                            if (payPalBtn) {
                                disableOnBlurClose.current = false;
                            }
                        } },
                        value,
                        payPalBtn && (React.createElement("div", { className: styles.hiddenBtn }, payPalBtn)))));
                }))))));
};
MeatballsMenu.displayName = 'MeatballsMenu';
